import React from 'react';
import { Text, TextButton } from 'library';
import { Grid } from '@material-ui/core';
import { MenuItem, Select } from '@mui/material';
import { DocumentToVerify, DropDownField, DocumentType } from '../models';
import { downloadFile } from 'parent-portal/provider-profile/tabs/documents/DocumentShared';

export default function EditDocumentType({
    form,
    updateDocType,
    currentDocType,
}: {
    form: DocumentToVerify;
    updateDocType: (value: DocumentType) => void;
    currentDocType?: DocumentType;
}) {
    if (!form.document_types) return null;

    const docTypeOptions: DropDownField[] = form.document_types.map((d) => ({
        name: d.document_link ? d.friendly_name + ' (1)' : d.friendly_name,
        value: d.document_type,
    }));

    function updateDocument(document_type_string: string) {
        const new_type = form?.document_types?.find((d) => d.document_type === document_type_string);
        if (new_type) updateDocType(new_type);
    }

    const selectedDoc = docTypeOptions.find((d) => d.value === currentDocType?.document_type);

    function downloadOtherDoc() {
        if (currentDocType?.document_link) {
            const link = currentDocType?.document_link.split('/api/')[1];
            downloadFile(`/api/${link}`);
        }
    }

    return (
        <Grid container item xs={12} direction="column" style={{ gap: 20 }}>
            <Text bold>Document Type: </Text>
            <Select
                value={selectedDoc?.value ?? ''}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                onChange={(e: any) => updateDocument(e.target.value)}
                label={'Document Type'}
                style={{ width: 400, height: 40 }}
            >
                {docTypeOptions.map((d, index) => (
                    <MenuItem key={index} value={d.value}>
                        {d.name}
                    </MenuItem>
                ))}
            </Select>
            {currentDocType?.document_link ? (
                <TextButton onClick={downloadOtherDoc}>Existing document for this type download to view.</TextButton>
            ) : null}
        </Grid>
    );
}
